import axios from "axios";
import {
  courseLoadingError,
  courseLoadingSuccess,
  coursesIsLoading,
  formSubmitError,
  formSubmitSuccess,
  isSubmittingForm,
  isSubmittingQuestionForm,
  questionFormSubmitError,
  questionFormSubmitSuccess,
  questionsLoadError,
  questionsLoading,
  questionsLoadSuccess,
  quizzesIsLoading,
  quizzesLoadingError,
  quizzesLoadingSuccess,
  resetFormStatus,
  resetQuestionFormStatus,
  settingsIsLoading,
  settingsLoadingSuccess,
  settingsLoadingError,
  announcementsIsLoading,
  announcementsLoadingSuccess,
  announcementsLoadingError,
  isUpdatingForm,
  formUpdateSuccess,
  formUpdateError,
  courseIntegrityError,
  statisticsIsLoading,
  statisticsLoadingSuccess,
  statisticsLoadingError,
  leadershipBoardIsLoading,
  leadershipBoardLoadingSuccess,
  leadershipBoardLoadingError,
  reportsIsLoading,
  reportsLoadingSuccess,
  reportsLoadingError,
  selectedCourseIsLoading,
  selectedCourseSuccess,
  selectedCourseError,
  loadComments,
  commentsLoadSuccess,
  commentsLoadError,
  courseLeadershipBoardIsLoading,
  courseLeadershipBoardLoadingSuccess,
  courseLeadershipBoardLoadingError,
  scheduleIsLoading,
  scheduleLoadingSuccess,
  scheduleLoadingError,
  monthIsLoading,
  monthLoadingSuccess,
  monthLoadingError,
  classesIsLoading,
  classesLoadingSuccess,
  classesLoadingError,
  categoriesIsLoading,
  categoriesLoadingSuccess,
  categoriesLoadingError,
  categoryItemsIsLoading,
  categoryItemsLoadingSuccess,
  categoryItemsLoadingError,
  liveCoursesIsLoading,
  liveCourseLoadingSuccess,
  liveCourseLoadingError,
  regSubjectSuccess,
  regSubjectFailError,
  liveSubjectSuccess,
  liveSubjectFailError,
  ExamscheduleIsLoading,
  ExamscheduleLoadingSuccess,
  ExamscheduleLoadingError,
  ExamAnswerSheetIsLoading,
  ExamAnswerSheetLoadingSuccess,
  ExamAnswerSheetLoadingError,
  ReportsStudentListIsLoading,
  ReportsStudentListLoadingSuccess,
  ReportsStudentListLoadingError,
  LoadTutorSubjectsIsLoading,
  LoadTutorSubjectsLoadingSuccess,
  LoadTutorSubjectsLoadingError,
  LoadTutorSubjectExamSchedulesIsLoading,
  LoadTutorSubjectExamSchedulesLoadingSuccess,
  LoadTutorSubjectExamSchedulesLoadingError,
  LoadExamScheduleStudentListIsLoading,
  LoadExamScheduleStudentListLoadingSuccess,
  LoadExamScheduleStudentListLoadingError
} from "../actions/actions";
const url = "https://simplifyed.io/dev-api/class/";

//Courses
export const loadCourses = () => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(coursesIsLoading());
    try {
      let response = await axios.get(url + "api/tutor/library", {
        headers: { Authorization: "Bearer " + token },
      });
      let courseData = [...response.data.payload.data];
      while (response.data.payload.next_page_url) {
        response = await axios.get(response.data.payload.next_page_url, {
          headers: { Authorization: "Bearer " + token },
        });
        courseData = courseData.concat(response.data.payload.data);
      }
      courseData.sort(
        (a, b) => Date.parse(b.created_at) - Date.parse(a.created_at)
      );
      dispatch(courseLoadingSuccess(courseData));
    } catch (error) {
      dispatch(courseLoadingError(error.message));
    }
  };
};

export const getCourses = async () => {
  //   const token = JSON.parse(window.localStorage.getItem("user")).access_token;

  return axios
    .get(url + "api/getSubjects", {
      //   headers: { Authorization: "Bearer " + token },
    })
    .then((res) => {
      if (res.status === 200) {
        return res.data && res.data.payload ? res.data.payload : [];
      } else {
        console.log("Error", res);
        return {};
      }
    })
    .catch((err) => {
      console.log("Error", err);
    });
};

export const getClasses_new = async () => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;

  return axios
    .get("https://simplifyed.io/dev-api/class/api/admin/getClasses", {
      headers: { Authorization: "Bearer " + token },
    })
    .then((res) => {
      if (res.status === 200) {
        return res.data && res.data.payload ? res.data.payload.data : [];
      } else {
        console.log("Error", res);
        return {};
      }
    })
    .catch((err) => {
      console.log("Error", err);
    });
};

export const getCategories_new = async () => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;

  return axios
    .get("https://simplifyed.io/dev-api/class/api/tutor/getCategories", {
      headers: { Authorization: "Bearer " + token },
    })
    .then((res) => {
      if (res.status === 200) {
        return res.data && res.data.payload ? res.data.payload.data : [];
      } else {
        console.log("Error", res);
        return {};
      }
    })
    .catch((err) => {
      console.log("Error", err);
    });
};

export const addCourse = async (formData) => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;

  return await axios
    .post(url + "api/tutor/library", formData, {
      headers: { Authorization: "Bearer " + token },
    })
    .then((res) => {
      if (res.status === 200) {
        return true;
      } else {
        return false;
      }
    })
    .catch((err) => {
    });
};

export const updateCourse = async (id, formData) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
  
    return await axios
      .post(url + "api/tutor/library/" + id, formData, {
        headers: { Authorization: "Bearer " + token },
      })
      .then((res) => {
        if (res.status === 200) {

          return res.data && res.data.payload ? res.data.payload : {};
        } else {
          return false;
        }
      })
      .catch((err) => {
      });
  };

export const getCourse = async (id) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
  
    return axios
      .get(url + "api/tutor/library/" + id, {
        headers: { Authorization: "Bearer " + token },
      })
      .then((res) => {
        if (res.status === 200) {
          return res.data && res.data.payload ? res.data.payload : {};
        } else {
          return [];
        }
      })
      .catch((err) => {
      });
  };

export const submitCourseForm = (formData) => {
  return async (dispatch) => {
    try {
      const token = JSON.parse(
        window.localStorage.getItem("user")
      ).access_token;
      dispatch(isSubmittingForm());
      let response = await axios.post(url + "api/tutor/courses", formData, {
        headers: { Authorization: "Bearer " + token },
      });
      if (!response.status === 200) {
        dispatch(
          formSubmitError(
            "Server Rejected Data with error code: " + response.status
          )
        );
      } else {
        dispatch(formSubmitSuccess());
        dispatch(resetFormStatus());
      }
    } catch (error) {
      dispatch(formSubmitError(error.message));
    }
  };
};

export const updateCourseForm = (formData, id) => {
  return async (dispatch) => {
    try {
      const token = JSON.parse(
        window.localStorage.getItem("user")
      ).access_token;
      dispatch(isSubmittingForm());
      let response = await axios.post(
        url + "api/tutor/courses/" + id,
        formData,
        { headers: { Authorization: "Bearer " + token } }
      );
      if (!response.status === 200) {
        dispatch(
          formSubmitError(
            "Server Rejected Data with error code: " + response.status
          )
        );
      } else {
        dispatch(formSubmitSuccess());
        dispatch(resetFormStatus());
      }
    } catch (error) {
      dispatch(formSubmitError(error.message));
    }
  };
};

export const loadEmptyCourses = () => {
  return async (dispatch) => {
    dispatch(coursesIsLoading());
    try {
      setTimeout(() => {
        dispatch(courseLoadingSuccess([]));
      }, 1000);
    } catch (error) {
      dispatch(courseLoadingError(error.message));
    }
  };
};

export const deleteCourse = (courses, id, courseToRemove) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(coursesIsLoading());
    try {
      let response = await axios.delete(url + "api/tutor/library/" + id, {
        headers: { Authorization: "Bearer " + token },
      });
      if (response.status === 200) {
        dispatch(courseLoadingSuccess(courses));
      } else if (response.status === 202) {
        dispatch(courseIntegrityError());
      } else {
        dispatch(
          courseLoadingError(
            "Server threw an error with status: " + response.status
          )
        );
      }
    } catch (error) {
      dispatch(courseLoadingError(error.message));
    }
  };
};

export const loadSettings = (formData) => {
  return async (dispatch) => {
    dispatch(settingsIsLoading());
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    try {
      let response = await axios.get(url + "api/tutor/settings", {
        headers: { Authorization: "Bearer " + token },
        params: {
          email: formData.email,
          token: token,
        },
      });
      let settingsData = { ...response.data.payload };
      dispatch(settingsLoadingSuccess(settingsData));
    } catch (error) {
      dispatch(settingsLoadingError(error.message));
    }
  };
};

export const updateProfile = (formData) => {
  return async (dispatch) => {
    dispatch(isUpdatingForm());
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    try {
      let response = await axios.post(
        url + "api/tutor/updateProfile",
        formData,
        { headers: { Authorization: "Bearer " + token } }
      );
      if (!response.status === 200) {
        dispatch(
          formUpdateError(
            "Server Rejected Data! with error code: " + response.status
          )
        );
      }
      dispatch(formUpdateSuccess());
      dispatch(resetFormStatus());
    } catch (error) {
      dispatch(formUpdateError(error.message));
    }
  };
};

export const submitChangePassword = (formData) => {
  return async (dispatch) => {
    dispatch(isSubmittingForm());
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    try {
      let response = await axios.post(
        url + "api/tutor/changePassword",
        formData,
        { headers: { Authorization: "Bearer " + token } }
      );
      if (!response.status === 200) {
        dispatch(
          formSubmitError(
            "Server Rejected Data! with error code: " + response.status
          )
        );
      }
      dispatch(formSubmitSuccess());
      dispatch(resetFormStatus());
    } catch (error) {
      dispatch(formSubmitError(error.message));
    }
  };
};

//Quizzes

export const loadEmptyQuizzes = () => {
  return async (dispatch) => {
    dispatch(quizzesIsLoading());
    try {
      setTimeout(() => {
        dispatch(quizzesLoadingSuccess([]));
      }, 1000);
    } catch (error) {
      dispatch(quizzesLoadingError(error.message));
    }
  };
};

export const loadQuizzes = () => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(quizzesIsLoading());
    try {
      let response = await axios.get(url + "api/tutor/quiz", {
        headers: { Authorization: "Bearer " + token },
      });
      let quizzesData = [...response.data.payload.data];
      while (response.data.payload.next_page_url) {
        response = await axios.get(response.data.payload.next_page_url, {
          headers: { Authorization: "Bearer " + token },
        });
        quizzesData = quizzesData.concat(response.data.payload.data);
      }
      quizzesData.sort(
        (a, b) => Date.parse(b.created_at) - Date.parse(a.created_at)
      );
      dispatch(quizzesLoadingSuccess(quizzesData));
    } catch (error) {
      dispatch(quizzesLoadingError(error.message));
    }
  };
};

export const deleteQuiz = (quizzes, id, quizToRemove) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(quizzesIsLoading());
    try {
      let response = await axios.delete(url + "api/tutor/quiz/" + id, {
        headers: { Authorization: "Bearer " + token },
      });
      if (response.status !== 200) {
        dispatch(
          quizzesLoadingError(
            "Server threw an error with status: " + response.status
          )
        );
      } else {
        dispatch(quizzesLoadingSuccess(quizzes));
      }
    } catch (error) {
      dispatch(quizzesLoadingError(error.message));
    }
  };
};

export const submitQuizForm = (formData) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    try {
      dispatch(isSubmittingForm());
      let response = await axios.post(url + "api/tutor/quiz", formData, {
        headers: { Authorization: "Bearer " + token },
      });
      // console.log(response)
      if (!response.status === 200) {
        dispatch(
          formSubmitError(
            "Server Rejected Data! with error code: " + response.status
          )
        );
      } else {
        // console.log("before local storage");
        localStorage.setItem("quizId", response.data.payload.id);
        dispatch(formSubmitSuccess());
        dispatch(resetFormStatus());
      }
    } catch (error) {
      // console.log(error.message)
      dispatch(formSubmitError(error.message));
    }
  };
};

export const updateQuizForm = (formData, id) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    try {
      dispatch(isSubmittingForm());
      let response = await axios.put(url + "api/tutor/quiz/" + id, formData, {
        headers: { Authorization: "Bearer " + token },
      });
      // console.log(response)
      if (!response.status === 200) {
        dispatch(
          formSubmitError(
            "Server Rejected Data! with error code: " + response.status
          )
        );
      } else {
        dispatch(formSubmitSuccess());
        dispatch(resetFormStatus());
      }
    } catch (error) {
      // console.log(error.message);
      dispatch(formSubmitError(error.message));
    }
  };
};

//Questions and Choices

export const submitQuestionAndChoices = (formData) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    try {
      dispatch(isSubmittingQuestionForm());
      let response = await axios.post(
        url + "api/tutor/quiz_questions",
        formData,
        { headers: { Authorization: "Bearer " + token } }
      );
      // console.log(response)
      if (!response.status === 200) {
        dispatch(
          formSubmitError(
            "Server Rejected Data! with error code: " + response.status
          )
        );
      } else {
        dispatch(questionFormSubmitSuccess());
        dispatch(resetQuestionFormStatus());
      }
    } catch (error) {
      console.log(error.response.data.message);
      dispatch(questionFormSubmitError(error.response.data.message));
    }
  };
};

export const loadQuizQuestions = (id) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    try {
      dispatch(questionsLoading());
      let response = await axios.get(
        url + `api/tutor/quiz/quiz_questions/${id}`,
        { headers: { Authorization: "Bearer " + token } }
      );
      let questions = response.data.payload;
      let displayQuestions = questions.map((question) => {
        return {
          question: {
            ...question,
            question_title: question.question,
            status: question.status,
          },
          choices: question.quiz_choices,
        };
      });
      dispatch(questionsLoadSuccess(displayQuestions));
    } catch (error) {
      dispatch(questionsLoadError(error.message));
    }
  };
};

export const deleteQuestion = (questions, id) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(questionsLoading());
    try {
      let response = await axios.delete(
        url + "api/tutor/quiz_questions/" + id,
        { headers: { Authorization: "Bearer " + token } }
      );
      if (response.status !== 200) {
        dispatch(
          questionsLoadError(
            "Server threw an error with status: " + response.status
          )
        );
      } else {
        dispatch(questionsLoadSuccess(questions));
      }
    } catch (error) {
      dispatch(questionsLoadError(error.message));
    }
  };
};

//non-redux api calls
export const deleteChoice = async (choices) => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;
  try {
    for (let choice of choices) {
      await axios.delete(url + `/api/tutor/choice/${choice.id}`, {
        headers: { Authorization: "Bearer " + token },
      });
    }
  } catch (error) {
    throw error;
  }
};

export const addChoice = async (choices, question_id) => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;
  try {
    for (let choice of choices) {
      let formData = { ...choice, question_id: question_id };
      await axios.post(url + "api/tutor/choice", formData, {
        headers: { Authorization: "Bearer " + token },
      });
    }
  } catch (error) {
    throw error;
  }
};

export const updateChoice = async (choices) => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;
  try {
    for (let i = 0; i < choices.length; i++) {
      let formData = {
        question_id: choices[i].question_id,
        choice: choices[i].choice,
        is_right_choice: choices[i].is_right_choice,
        status: choices[i].status,
      };
      await axios.put(url + `api/tutor/choice/${choices[i].id}`, formData, {
        headers: { Authorization: "Bearer " + token },
      });
      // console.log(
      //     response.status +
      //     " for choice no. " +
      //     choices[i].id +
      //     " which is " +
      //     choices[i].choice
      // );
    }
  } catch (error) {
    throw error;
  }
  /*
      "question_id":1,
      "choice": "update choice 1",
      "is_right_choice": "Y",
      "status": "Y"
      */
};

export const updateQuestion = async (id, formData) => {
  let data = {};
  data["question"] = formData.question_title;
  data["no_of_choices"] = formData.no_of_choices;
  data["quiz_id"] = formData.quiz_id;
  data["status"] = formData.status;
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;
  try {
    let response = await axios.put(url + `api/quiz_questions/${id}`, data, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data.payload;
  } catch (error) {
    throw error;
  }
};

export const addOneQuestionAndChoices = async (formData) => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;
  try {
    await axios.post(url + "api/quiz_questions", formData, {
      headers: { Authorization: "Bearer " + token },
    });
  } catch (error) {
    throw error;
  }
};

export const loadAnnouncements = () => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(announcementsIsLoading());
    try {
      let response = await axios.get(url + "api/tutor/announcements", {
        headers: { Authorization: "Bearer " + token },
      });
      let announcementsData = [...response.data.payload.data];
      while (response.data.payload.next_page_url) {
        response = await axios.get(response.data.payload.next_page_url, {
          headers: { Authorization: "Bearer " + token },
        });
        announcementsData = announcementsData.concat(
          response.data.payload.data
        );
      }
      announcementsData.sort(
        (a, b) => Date.parse(b.created_at) - Date.parse(a.created_at)
      );
      dispatch(announcementsLoadingSuccess(announcementsData));
    } catch (error) {
      dispatch(announcementsLoadingError(error.message));
    }
  };
};

export const deleteAnnouncement = (announcements, id, announcementToRemove) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(announcementsIsLoading());
    try {
      let response = await axios.delete(url + "api/tutor/announcements/" + id, {
        headers: { Authorization: "Bearer " + token },
      });
      if (response.status !== 200) {
        dispatch(
          courseLoadingError(
            "Server threw an error with status: " + response.status
          )
        );
      } else {
        dispatch(announcementsLoadingSuccess(announcements));
      }
    } catch (error) {
      dispatch(announcementsLoadingError(error.message));
    }
  };
};

export const loadStatistics = (type, id) => {
  return async (dispatch) => {
    dispatch(statisticsIsLoading());
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    let route =
      type === "main"
        ? "api/tutor/dashboard"
        : "api/tutor/course_dashboard/" + id;
    try {
      let response = await axios.get(url + route, {
        headers: { Authorization: "Bearer " + token },
      });
      let statisticsData =
        "end_term_quizz" in response.data.payload
          ? [response.data.payload]
          : [...response.data.payload];
      dispatch(statisticsLoadingSuccess(statisticsData));
    } catch (error) {
      dispatch(statisticsLoadingError(error));
    }
  };
};

export const loadLeadershipBoard = () => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;
  return async (dispatch) => {
    dispatch(leadershipBoardIsLoading());
    try {
      let response = await axios.get(url + "api/tutor/leadership_dashboard", {
        headers: { Authorization: "Bearer " + token },
      });
      let leadershipBoardData = [...response.data.payload];
      leadershipBoardData.sort((a, b) => b.scores_count - a.scores_count);
      dispatch(leadershipBoardLoadingSuccess(leadershipBoardData));
    } catch (error) {
      dispatch(leadershipBoardLoadingError(error.message));
    }
  };
};

export const loadCourseLeadershipBoard = (id) => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;
  return async (dispatch) => {
    dispatch(courseLeadershipBoardIsLoading());
    try {
      let response = await axios.get(
        url + "api/tutor/course_leadership_board/" + id,
        { headers: { Authorization: "Bearer " + token } }
      );
      let leadershipBoardData = [...response.data.payload];
      leadershipBoardData.sort((a, b) => b.scores_count - a.scores_count);
      dispatch(courseLeadershipBoardLoadingSuccess(leadershipBoardData));
    } catch (error) {
      dispatch(courseLeadershipBoardLoadingError(error.message));
    }
  };
};

export const loadReports = () => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    const user = JSON.parse(window.localStorage.getItem("user")).user;
    const id = user.id;
    dispatch(reportsIsLoading());
    try {
      let response = await axios.get(url + "api/tutor/analytics/Statistics/"+id, {
        headers: { Authorization: "Bearer " + token },
      });
      let reportsData = { ...response.data.payload };
      dispatch(reportsLoadingSuccess(reportsData));
    } catch (error) {
      dispatch(reportsLoadingError(error.message));
    }
  };
};

export const loadStudentReports = () => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(ReportsStudentListIsLoading());
    try {
      let response = await axios.get(url + "api/tutor/analytics/students", {
        headers: { Authorization: "Bearer " + token },
      });
      let ReportStudentListData = { ...response.data.payload };
      dispatch(ReportsStudentListLoadingSuccess(ReportStudentListData));
    } catch (error) {
      dispatch(ReportsStudentListLoadingError(error.message));
    }
  };
};

export const loadTutorSubjects = () => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(LoadTutorSubjectsIsLoading());
    try {
      let response = await axios.get(url + "api/tutor/getSubjects", {
        headers: { Authorization: "Bearer " + token },
      });
      let TutorSubjectsList = { ...response.data.payload };
      dispatch(LoadTutorSubjectsLoadingSuccess(TutorSubjectsList));
    } catch (error) {
      dispatch(LoadTutorSubjectsLoadingError(error.message));
    }
  };
};

export const LoadTutorSubjectExamSchedules = (id) => {
  console.log(id,"id");
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(LoadTutorSubjectExamSchedulesIsLoading());
    try {
      let response = await axios.get(url + "api/tutor/analytics/schedule/statistics/"+id, {
        headers: { Authorization: "Bearer " + token },
      });
      let TutorSubjectExamSchedules = { ...response.data.payload };
      dispatch(LoadTutorSubjectExamSchedulesLoadingSuccess(TutorSubjectExamSchedules));
    } catch (error) {
      dispatch(LoadTutorSubjectExamSchedulesLoadingError(error.message));
    }
  };
};

export const LoadExamScheduleStudentList = (id) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(LoadExamScheduleStudentListIsLoading());
    try {
      let response = await axios.get(url + "api/tutor/analytics/schedule/students/"+id, {
        headers: { Authorization: "Bearer " + token },
      });
      let ExamScheduleStudentList = { ...response.data.payload };
      dispatch(LoadExamScheduleStudentListLoadingSuccess(ExamScheduleStudentList));
    } catch (error) {
      dispatch(LoadExamScheduleStudentListLoadingError(error.message));
    }
  };
};

export const loadSelectedCourse = (id) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(selectedCourseIsLoading());
    try {
      let response = await axios.get(url + "api/tutor/courses/" + id, {
        headers: { Authorization: "Bearer " + token },
      });
      let course = response.data.payload;
      response = await axios.get(url + "api/tutor/course_topics/" + id, {
        headers: { Authorization: "Bearer " + token },
      });
      course["topics"] = response.data.payload;
      dispatch(selectedCourseSuccess(course));
    } catch (error) {
      dispatch(selectedCourseError(error.message));
    }
  };
};

export const loadCourseComments = (id) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(loadComments());
    try {
      let response = await axios.get(url + "api/tutor/course_comments/" + id, {
        headers: { Authorization: "Bearer " + token },
      });
      let commentsData = [...response.data.payload.data];
      while (response.data.payload.next_page_url) {
        response = await axios.get(response.data.payload.next_page_url, {
          headers: { Authorization: "Bearer " + token },
        });
        commentsData = commentsData.concat(response.data.payload.data);
      }
      console.log(commentsData);
      commentsData.sort(
        (a, b) => Date.parse(b.created_at) - Date.parse(a.created_at)
      );
      dispatch(commentsLoadSuccess(commentsData));
    } catch (error) {
      dispatch(commentsLoadError(error.response.data.message));
    }
  };
};

export const loginUser = async (loginDetails) => {
  try {
    let response = await axios.post(
      "https://simplifyed.io/dev-api/class/api/tutor/login",
      loginDetails
    );
    console.log(response.data.payload);
    return response.data.payload;
  } catch (error) {
    throw error;
  }
};

export const logout = async () => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;
  try {
    await axios.post("https://simplifyed.io/dev-api/class/api/tutor/logout", {
      headers: { Authorization: "Bearer " + token },
    });
    return true;
  } catch (error) {
    throw error;
  }
};

export const loadMonth = (year, month) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    console.log(token, "token");
    dispatch(monthIsLoading());
    try {
      let response = await axios.get(
        `https://simplifyed.io/dev-api/class/api/tutor/academic_calendars/${year}/${month}`,
        { headers: { Authorization: "Bearer " + token } }
      );
      let calendarData = [...response.data.payload.data];
      console.log(calendarData,"ca");
    
      dispatch(monthLoadingSuccess(calendarData));
    } catch (error) {
      console.log(error.response);
      dispatch(monthLoadingError(error.response));
    }
  };
};

export const loadSchedule = (
  startDate,
  endDate,
  classId,
  degreeId,
  specificationId,
  defaultSchedule = false
) => {
  return async (dispatch) => {
    dispatch(scheduleIsLoading());
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    let body = {
      start_date: startDate,
      end_date: endDate,
      class_id: Number(classId),
      degree_id: Number(degreeId),
      specification_id: Number(specificationId),
    };
    console.log(body,"class");
    
    let expectedDates = [];
    let start = Number(startDate.substring(startDate.length - 2));
    let end = Number(endDate.substring(endDate.length - 2));
    let restOfTheDate = startDate.substring(0, startDate.length - 2);
    for (let i = start; i <= end; i++) {
      expectedDates.push(restOfTheDate + (i < 10 ? "0" + i : i));
    }
    try {
      let response = await axios.post(
        "https://simplifyed.io/dev-api/class/api/tutor/manageSchedules",
        body,
        { headers: { Authorization: "Bearer " + token } }
      );
      let scheduleData = { ...response.data.payload };
      let incomingDates = Object.keys(scheduleData);
      let emptySessions = {
        Session1: null,
        Session2: null,
        Session3: null,
        Session4: null,
        Session5: null,
      };
      if (defaultSchedule && incomingDates.length < 6) {
        let newScheduleData = {};
        expectedDates.forEach((date) => {
          if (!incomingDates.includes(date)) {
            newScheduleData[date] = emptySessions;
          } else {
            newScheduleData[date] = scheduleData[date];
          }
        });
        dispatch(scheduleLoadingSuccess(newScheduleData));
      } else {
        dispatch(scheduleLoadingSuccess(scheduleData));
      }
    } catch (error) {
      console.log(error);
      dispatch(scheduleLoadingError(error.message));
    }
  };
};

export const registerUser = async (registerData) => {
  try {
    let response = await axios.post(
      "https://simplifyed.io/dev-api/class/api/tutor_enroll",
      registerData
    );
    console.log(response.data.payload);
    return true;
  } catch (error) {
    throw error;
  }
};

export const setSessionType = async (
  scheduleId,
  description,
  categoryId,
  libraryId
) => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;
  try {
    
    let body = {
      schedule_id: Number(scheduleId),
      description: description,
      category_id: categoryId,
      library_id: libraryId,
    };
    console.log(body);
    let response = await axios.post(
      "https://simplifyed.io/dev-api/class/api/tutor/manageClasses",
      body,
      { headers: { Authorization: "Bearer " + token } }
    );
    console.log(response);
    return response.status === 200;
  } catch (error) {
    throw error;
  }
};

export const getClasses = () => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(classesIsLoading());
    try {
      let response = await axios.get(
        "https://simplifyed.io/dev-api/class/api/tutor/classes",
        { headers: { Authorization: "Bearer " + token } }
      );
      console.log(response, "classes");
      let classData = [...response.data.payload.data];
      while (response.data.payload.next_page_url) {
        response = await axios.get(response.data.payload.next_page_url, {
          headers: { Authorization: "Bearer " + token },
        });
        classData = classData.concat(response.data.payload.data);
      }
      dispatch(classesLoadingSuccess(classData));
    } catch (error) {
      console.log(error.response);
      dispatch(classesLoadingError(error));
    }
  };
};

export const getCategories = () => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(categoriesIsLoading());
    try {
      let response = await axios.get(
        "https://simplifyed.io/dev-api/class/api/tutor/manageCategories",
        { headers: { Authorization: "Bearer " + token } }
      );

      let response1 = await axios.get(
        "https://simplifyed.io/dev-api/class/api/admin/getClasses",
        { headers: { Authorization: "Bearer " + token } }
      );

      let response2 = await axios.get(
        "https://simplifyed.io/dev-api/class/api/admin/manageSubjects",
        { headers: { Authorization: "Bearer " + token } }
      );

      let categoriesData = [...response.data.payload.data];
      while (response.data.payload.next_page_url) {
        response = await axios.get(response.data.payload.next_page_url, {
          headers: { Authorization: "Bearer " + token },
        });
        categoriesData = categoriesData.concat(response.data.payload.data);
      }

      const payload = {
        categoriesData: categoriesData,
        classesData: response1.data.payload.data,
        subjectData: response2.data.payload.data,
      };

      dispatch(categoriesLoadingSuccess(payload));
    } catch (error) {
      console.log(error.response);
      dispatch(categoriesLoadingError(error));
    }
  };
};

export const getCategoryItems = (categoryId, scheduleId) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(categoryItemsIsLoading());
    try {
      let response = await axios.get(
        `https://simplifyed.io/dev-api/class/api/tutor/manageLibrary/${categoryId}/${scheduleId}`,
        { headers: { Authorization: "Bearer " + token } }
      );
      let categoryItemsData = [...response.data.payload.data];
      while (response.data.payload.next_page_url) {
        response = await axios.get(response.data.payload.next_page_url, {
          headers: { Authorization: "Bearer " + token },
        });
        categoryItemsData = categoryItemsData.concat(
          response.data.payload.data
        );
      }
      dispatch(categoryItemsLoadingSuccess(categoryItemsData));
    } catch (error) {
      console.log(error);
      dispatch(categoryItemsLoadingError(error));
    }
  };
};

export const submitLiveCourseForm = (meetingData, accessToken) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    try {
      dispatch(isSubmittingForm());
      console.log(accessToken);
      let response = await axios.post(
        "https://webexapis.com/v1/meetings",
        meetingData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      console.log(response.data);
      let createdMeeting = response.data;
      let formData = {
        meeting_id: createdMeeting.id,
        meeting_number: createdMeeting.meetingNumber,
        title: createdMeeting.title,
        agenda: createdMeeting.agenda,
        start: createdMeeting.start,
        end: createdMeeting.end,
        host_user_id: createdMeeting.hostUserId,
        host_email: createdMeeting.hostEmail,
        host_name: createdMeeting.hostDisplayName,
        host_key: createdMeeting.hostKey,
        web_link: createdMeeting.webLink,
      };
      response = await axios.post(url + "api/tutor/meetings", formData, {
        headers: { Authorization: "Bearer " + token },
      });
      if (!response.status === 200) {
        dispatch(
          formSubmitError(
            "Server Rejected Data with error code: " + response.status
          )
        );
      } else {
        dispatch(formSubmitSuccess());
        dispatch(resetFormStatus());
      }
    } catch (error) {
      console.log(error.response.data.message);
      dispatch(formSubmitError(error.response.data.message));
    }
  };
};

export const loadLiveCourses = () => {
  return async (dispatch) => {
    dispatch(liveCoursesIsLoading());
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    try {
      let response = await axios.get(url + "api/tutor/meetings", {
        headers: { Authorization: "Bearer " + token },
      });
      let liveCourseData = [...response.data.payload.data];
      while (response.data.payload.next_page_url) {
        response = await axios.get(response.data.payload.next_page_url, {
          headers: { Authorization: "Bearer " + token },
        });
        liveCourseData = liveCourseData.concat(response.data.payload.data);
      }
      liveCourseData.sort(
        (a, b) => Date.parse(b.created_at) - Date.parse(a.created_at)
      );
      dispatch(liveCourseLoadingSuccess(liveCourseData));
    } catch (error) {
      dispatch(liveCourseLoadingError(error.message));
    }
  };
};

export const loadRegSubjects = () => {
  return async (dispatch) => {
    try {
      // let response = await axios.get(url + "api/admin/manageSubjects", { headers: { 'Authorization': 'Bearer '} });
      const response = {
        payload: {
          current_page: 1,
          data: [
            {
              id: 1,
              name: "Computer Science",
              created_at: "2021-10-22 02:49:17",
              updated_at: "2021-10-22 02:49:17",
            },
            {
              id: 2,
              name: "Data Science",
              created_at: "2021-10-22 02:49:17",
              updated_at: "2021-10-22 02:49:17",
            },
            {
              id: 3,
              name: "History",
              created_at: "2021-10-22 02:49:17",
              updated_at: "2021-10-22 02:49:17",
            },
            {
              id: 4,
              name: "Physics",
              created_at: "2021-10-22 02:49:17",
              updated_at: "2021-10-22 02:49:17",
            },
            {
              id: 5,
              name: "Chemistry",
              created_at: "2021-10-22 02:49:17",
              updated_at: "2021-10-22 02:49:17",
            },
          ],
        },
      };
      let reportsData = response.payload.data;
      dispatch(regSubjectSuccess(reportsData));
    } catch (error) {
      dispatch(regSubjectFailError(error.message));
    }
  };
};

export const loadLiveSubjects = () => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;
  return async (dispatch) => {
    try {
      let response = await axios.get(url + "api/admin/manageSubjects", {
        headers: { Authorization: "Bearer " + token },
      });
      const classResponse = await axios.get(url + "api/admin/getClasses", {
        headers: { Authorization: "Bearer " + token },
      });
      const payload = {
        subjectsData: response.data.payload.data,
        classesData: classResponse.data.payload.data,
      };
      dispatch(liveSubjectSuccess(payload));
    } catch (error) {
      dispatch(liveSubjectFailError(error.message));
    }
  };
};


export const loadExamSchedule = (
  degreeId,
  specificationId,classId) => {
    return async(dispatch) => {
      let body = {
      class_id: Number(classId),
      degree_id: Number(degreeId),
      specification_id: Number(specificationId),
    };
        dispatch(ExamscheduleIsLoading());
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        
        try {
          let response = await axios.post(
        "https://simplifyed.io/dev-api/class/api/tutor/getSchedules",
        body,
        { headers: { Authorization: "Bearer " + token } }
      );

            let ExamscheduleData = {...response.data.payload};
            dispatch(ExamscheduleLoadingSuccess(ExamscheduleData));
        } catch (error) {
            console.log(error)
            dispatch(ExamscheduleLoadingError(error.message));
        }
    };
};


export const loadExamAnswerSheets = (degreeId,
  specificationId,classId) => {
    return async(dispatch) => {
      let body = {
      class_id: Number(classId),
      degree_id: Number(degreeId),
      specification_id: Number(specificationId),
    };
        dispatch(ExamAnswerSheetIsLoading());
        const token = JSON.parse(window.localStorage.getItem("user")).access_token
        
        try {
           let response = await axios.post(
        "https://simplifyed.io/dev-api/class/api/tutor/getExamAnswers",
        body,
        { headers: { Authorization: "Bearer " + token } }
      ); 
             let ExamAnswersData = {...response.data.payload};
            dispatch(ExamAnswerSheetLoadingSuccess(ExamAnswersData));
        } catch (error) {
            dispatch(ExamAnswerSheetLoadingError(error.message));
        }
    };
};

export const getDegree = async () => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;

  return axios
    .get(url + "api/tutor/getDegree", {
      headers: { Authorization: "Bearer " + token },
    })
    .then((res) => {
      if (res.status === 200) {
        return res.data && res.data.payload ? res.data.payload : [];
      } else {
        console.log("Error", res);
        return [];
      }
    })
    .catch((err) => {
      console.log("Error", err);
    });
};

export const getSpecification = async (id) => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;

    fetch(url + "api/tutor/getSpecifications/" + id, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function(response){ return response.json(); })
    .then(function(data) {
        const items = data;
        return items;
    })
};
export const submitQuestionDocs= (formData) => {
    return async(dispatch) => {
        

            const token = JSON.parse(window.localStorage.getItem("user")).access_token
            let response = await axios.post(url + "api/tutor/add/questions", formData, { headers: { 'Authorization': 'Bearer ' + token } });
            if (response.data.code === 200) {
                dispatch(formSubmitSuccess());
                dispatch(resetFormStatus());

               
            } else {
                dispatch(
                    formSubmitError(
                        "Server Rejected Data with error code: " + response.status
                    )
                );
            }
       
    };
};

export const submitCorrectedAnswerDocs= (formData) => {
    return async(dispatch) => {
            const token = JSON.parse(window.localStorage.getItem("user")).access_token
            let response = await axios.post(url + "api/tutor/update/result", formData, { headers: { 'Authorization': 'Bearer ' + token } });
            if (response.data.code === 200) {
                dispatch(formSubmitSuccess());
                dispatch(resetFormStatus());

               
            } else {
                dispatch(
                    formSubmitError(
                        "Server Rejected Data with error code: " + response.status
                    )
                );
            }
       
    };
};

export const loadYearfilter = (
  degree_id,
  specification_id,
  year_id,
 
) => {
  return async (dispatch) => {
    dispatch(ExamAnswerSheetIsLoading());
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    let body = {
      degree_id: degree_id,
      specification_id: specification_id,
      year_id: year_id,
    };    
    
    try {
      let response = await axios.post(
        "https://simplifyed.io/dev-api/class/api/tutor/yearFilter",
        body,
        { headers: { Authorization: "Bearer " + token } }
      );
      let ExamscheduleData = { ...response.data.payload };
      dispatch(ExamscheduleLoadingSuccess(ExamscheduleData));
    } catch (error) {
      dispatch(ExamscheduleLoadingError(error.message));
    }
  };
};
